import { useInjection } from 'inversify-react';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import type { IAnalyticsService } from '../../services/analytics/analytics.service.interface';

export function usePageViewTracking() {
  const analytics = useInjection<IAnalyticsService>(AnalyticsService);
  const { pathname } = useLocation();

  useEffect(() => {
    analytics.trackPageView(pathname);
  }, [analytics, pathname]);
}
